module.exports = __webpack_public_path__ + "img/dexnet.8962308f.svg";